import { CSSProperties } from 'react';

import { FlattenSimpleInterpolation } from 'styled-components';

import { CustomCss, CustomInlineStyle, PaletteColor } from '@utils/types';

import CheckedIcon from './CheckedIcon';
import {
  CheckboxContainer,
  HiddenCheckbox,
  Label,
  SegLabel,
  SegmentContainer,
  CheckboxContainerSapData,
} from './styled';
import { ModeHooks, CheckboxModeType } from './hooks';

export type OutlineSpecsProps = Partial<{
  className: string;
  testid: string;
  labelCss: CustomCss;
  labelStyle: CustomInlineStyle;
  onChange?: (value: boolean) => void;
  LabelComponent?: React.ComponentType<
    React.PropsWithChildren<{
      style?: CSSProperties;
      customCss?: FlattenSimpleInterpolation;
    }>
  >;
  SegmentLabel?: React.ComponentType<
    React.PropsWithChildren<{
      style?: CSSProperties;
      customCss?: FlattenSimpleInterpolation;
    }>
  >;
  checked: boolean;
  mode?: CheckboxModeType;
  disabled?: boolean;
  outlineColor?: PaletteColor;
  checkMarkColor?: PaletteColor;
  checkOnLabelClick?: boolean;
  segment?: boolean;
  sapData?: boolean;
}>;

const CheckboxOutline = ({
  className,
  children,
  testid,
  labelStyle,
  labelCss,
  onChange,
  checked: initialValue,
  LabelComponent = Label,
  SegmentLabel = SegLabel,
  mode = 'uncontrolled',
  checkMarkColor,
  outlineColor,
  checkOnLabelClick = true,
  segment,
  sapData,
  ...rest
}: React.PropsWithChildren<OutlineSpecsProps>) => {
  const [checked, setChecked] = ModeHooks[mode](initialValue ?? false);
  const onClick = () => {
    setChecked((state) => {
      onChange?.(!state);
      return !state;
    });
  };
  const clickProps = checkOnLabelClick && !rest.disabled ? { onClick } : {};
  return (
    <>
      {segment ? (
        <SegmentContainer
          className={className}
          data-testid={testid}
          {...clickProps}
        >
          <HiddenCheckbox
            checked={checked}
            readOnly
            {...rest}
            type='checkbox'
          />
          <CheckedIcon
            segment={segment}
            checked={checked}
            checkMarkColor={checkMarkColor}
            outlineColor={outlineColor}
            onClick={rest.disabled ? undefined : onClick}
          />
          <SegmentLabel style={labelStyle} customCss={labelCss}>
            {children}
          </SegmentLabel>
        </SegmentContainer>
      ) : (
        <>
          {sapData ? (
            <CheckboxContainerSapData
              className={className}
              data-testid={testid}
              {...clickProps}
            >
              <HiddenCheckbox
                checked={checked}
                readOnly
                {...rest}
                type='checkbox'
              />
              <CheckedIcon
                segment={segment}
                checked={checked}
                checkMarkColor={checkMarkColor}
                outlineColor={outlineColor}
                onClick={rest.disabled ? undefined : onClick}
              />
              <LabelComponent style={labelStyle} customCss={labelCss}>
                {children}
              </LabelComponent>
            </CheckboxContainerSapData>
          ) : (
            <CheckboxContainer
              className={className}
              data-testid={testid}
              {...clickProps}
            >
              <HiddenCheckbox
                checked={checked}
                readOnly
                {...rest}
                type='checkbox'
              />
              <CheckedIcon
                segment={segment}
                checked={checked}
                checkMarkColor={checkMarkColor}
                outlineColor={outlineColor}
                onClick={rest.disabled ? undefined : onClick}
              />
              <LabelComponent style={labelStyle} customCss={labelCss}>
                {children}
              </LabelComponent>
            </CheckboxContainer>
          )}
        </>
      )}
    </>
  );
};
export default CheckboxOutline;

export { CheckboxContainer };
